<template>
  <div>
    <el-form-item :label="$t('默认行数')">
      <el-input-number v-model="data.rows"
                       controls-position="right"
                       :placeholder="$t('请输入')"></el-input-number>
    </el-form-item>
    <el-form-item :label="$t('排序字段')">
      <el-select v-model="data.orderId" filterable :placeholder="$t('请选择')">
          <el-option
            v-for="item in getFields(data.table)"
            :key="item.name"
            :label=" item.coment? `${item.name}(${item.coment})` : item.name"
            :value="item.name">
          </el-option>
      </el-select>
    </el-form-item>
    <el-form-item v-if="data.table" :label="$t('是否倒序')">
      <el-switch v-model="data.isDESC" ></el-switch>
    </el-form-item>
    <el-form-item :label="$t('添加按钮')">
      <el-switch v-model="data.isAddBtn" ></el-switch>
    </el-form-item>
    <el-form-item :label="$t('按钮文本')">
        <el-input v-model="data.addBtnText" ></el-input>
    </el-form-item>
    <el-form-item :label="$t('删除按钮')">
      <el-switch v-model="data.isRemoveBtn" ></el-switch>
    </el-form-item> 
    <el-form-item :label="$t('详情按钮')">
      <el-switch v-model="data.isDetailBtn" ></el-switch>
    </el-form-item>
    <el-form-item v-if="data.isDetailBtn" :label="$t('详情链接')">
      <el-input v-model="data.detailUrl"></el-input>
    </el-form-item>
    <el-form-item :label="$t('序号列')">
      <el-switch v-model="data.isShowNum" ></el-switch>
    </el-form-item>
    <el-form-item :label="$t('是否必填')">
      <el-switch v-model="data.required" ></el-switch>
    </el-form-item>
    <el-form-item :label="$t('显示合计')">
      <el-switch v-model="data.showSummary" ></el-switch>
    </el-form-item>
    <el-divider>{{ $t("表头合并") }}</el-divider>
    <template v-if="data.mergeHeader">
      <div
        class="reg-item"
        :key="index"
        v-for="(item, index) in data.mergeHeader"
      >
        <el-form-item
          label-width="48px"
          :label="$t('名称')"
          style="margin-bottom: 8px"
        >
          <el-input v-model="item.label" :placeholder="$t('请输入')"></el-input>
        </el-form-item>
        <el-form-item
          label-width="48px"
          :label="$t('子列')"
          style="margin-bottom: 8px"
        >
          <l-select
            v-model="item.value"
            multiple
            :placeholder="$t('请选择')"
            :options="getColumns(item.prop)"
          />
        </el-form-item>
        <el-form-item
          label-width="48px"
          :label="$t('对齐')"
          style="margin-bottom: 0"
        >
          <l-select v-model="item.align" :options="alignOptions" />
        </el-form-item>

        <el-button
          :title="$t('删除')"
          @click="handleRemoveCol(index)"
          class="reg-item-delete"
          circle
          plain
          size="mini"
          type="danger"
        >
          <i class="el-icon-close"></i>
        </el-button>
      </div>
    </template>
    <div class="mt-8">
      <el-button type="primary" size="mini" @click="handleAddCol">{{
        $t("添加")
      }}</el-button>
    </div>
    <div class="mt-8"  v-if="!isNoScript" >
        <el-button @click="handleBtnClick('changeDataEvent','添加行数据改变脚本')"  type="primary" size="mini" >添加行数据改变脚本</el-button>
    </div>
    <l-dialog 
        :title="formTitle"
        :visible.sync="formVisible"
        :height="528"
        :width="1000"
        @ok="handleCodeSave"
        @opened="handleOpenedForm"
        >
        <l-layout :right="400">
          <l-code-mirror v-model="code" isHint :handleHint="handleHint" mode="application/javascript" ></l-code-mirror>
          <template #right>
            <l-code-mirror readOnly v-model="tempCode" >
            </l-code-mirror>
          </template>
        </l-layout>
    </l-dialog>
  </div>
</template>

<script>
export default {
  name: "config-gridtable",
  inject: ["formDesign"],
  props: ['data'],
  data () {
    return {
      formTitle:'',
      formVisible:false,
      code:'',
      type:'',
      alignOptions: [
        { value: "left", label: this.$t("靠左") },
        { value: "center", label: this.$t("居中") },
        { value: "right", label: this.$t("靠右") },
      ],
      tempCode:`
// 示例代码,只支持ES5语法
// 获取表单是新增还是编辑
var isUpdate = learun.isUpdate

// 组件id
var id = learun.prop
// 组件变更数据
var data = learun.data
// 子组件变更行号 rowIndex
var rowIndex = learun.tableIndex

// 获取主表数据
var value = learun.get('组件id')
// 获取子表行数据
var childRow = learun.get('子表组件id.行号')
// 获取子表单元格数据
var childCell = learun.get('子表组件id.行号.单元格组件id')

// 设置主表数据
learun.set({path:'组件id',value:'xxxx'})
// 添加子表行数据
var row = {}
learun.set({path:'子表组件id',value:row,type:'addTable'})
// 删除子表行数据
learun.set({path:'子表组件id.行号',type:'deleteTable'})
// 设置子表某一个单元格数据
learun.set({path:'子表组件id.行号.单元格组件id',value:'xxxxxx'})

// 获取主表字段显示值（针对下拉框等）
var label = learun.getLabel('组件id')
// 获取子表单元格显示值
var cellLabel =  learun.getLabel('子表组件id.行号.单元格组件id')

// 设置组件为必填
learun.setRequired('组件id')
// 设置组件不为必填
learun.setRequired('组件id',false)

// 设置组件为只读
learun.setDisabled('组件id')
// 取消组件为只读
learun.setDisabled('组件id',false)

// 设置组件为隐藏
learun.setHide('组件id')
// 取消组件隐藏
learun.setHide('组件id',false)

// 去掉子表某一行删除按钮
learun.set({path:'子表组件id.行号.hasNoDeleteBtn',value:false})
// 让子表某一行变成不可编辑
learun.set({path:'子表组件id.行号.disabled',value:true})
// 让子表某一行除了某一列外不可以编辑
learun.set({path:'子表组件id.行号.disabled',value:true})
learun.set({path:'子表组件id.行号.abledList',value:['编辑列组件id']})


// 显示表单加载动画
learun.loading('数据加载中')
// 关闭表单加载状态
learun.hideLoading('数据加载中')

// 提示消息
learun.message('我是力软小力')

// 获取登录者信息
var loginUser = learun.loginUser

// get请求
// 需要用到回调方法
var getCallback = function(res){ console.log(res)//请求结果 }
learun.httpGet({url:api地址,params:{},getCallback})

// post请求
// 需要用到回调方法
var postCallback = function(res){ console.log(res)//请求结果 }
learun.httpPost({url:api地址,params:{},data:{},postCallback})

// put请求
// 需要用到回调方法
var putCallback = function(res){ console.log(res)//请求结果 }
learun.httpPut({url:api地址,params:{},data:{},putCallback})

// post请求
// 需要用到回调方法
var deleteCallback = function(res){ console.log(res)//请求结果 }
learun.httpDelete({url:api地址,params:{},data:{},deleteCallback})

// 如果用来上述的请求，用了回掉方法，请最后写
return 'callback'

            `
    }
  },
  computed:{
    isNoScript(){
      return this.formDesign.isNoScript;
    },
    columns() {
      const res = [];

      if (this.data.mergeHeader) {
        this.data.mergeHeader.forEach((t) => {
          res.push({ label: t.label, value: t.prop });
        });
      }
      res.push(
        ...this.data.children.map((t) => ({ label: t.label, value: t.prop }))
      );

      return res;
    },
  },
  mounted() {
    if (this.data.showSummary == undefined) {
      this.$set(this.data, "showSummary", false);
    }
  },
  methods: {
    handleBtnClick(type,title){
        this.type = type
        this.formTitle = title
        this.formVisible = true
    },
    getEvent(strEvent){
      // 获取事件方法
      if(!this.$validatenull(strEvent)){
          if(strEvent.indexOf('=>') != -1){
              // 表示是老版本，提示其修改为新的版本
              console.warn('当前脚本不支持ES6语法，只支持ES5语法')
              return  {res:false,msg:'脚本没有更新为最新的版本！'}
          }
          else{
              strEvent = `(function(){function fn(learun) {${strEvent}} return fn})()`
              return this.$getFunction(strEvent)
          }
      }
      else{
         return  {res:true}
      }
    },
    handleCodeSave(){
        const {res,msg} = this.getEvent(this.code)
        if(res){
            this.data[this.type] = this.code
            this.formVisible = false
        }
        else{
            this.$message({
                type: 'error',
                message: `${this.$t('脚本错误')}:${msg}`
            })
        }
    },
    handleOpenedForm(){
      this.code = this.data[this.type] || ''
    },
    getFields(tableName){
      const table = this.formDesign.dbTables.find(t=>t.name == tableName) || {}
      return table.columns || []
    },
    handleHint(text){
        text = text.replace(/'/g,'')
        text = text.replace(/"/g,'')
        const myList = this.formDesign.componentList.filter(t=>t.pprop == this.data.prop  && (t.label.indexOf(text) != -1 ||  t.prop.indexOf(text) != -1))
        const list = this.formDesign.componentList.filter(t=>t.pprop != this.data.prop  && (t.label.indexOf(text) != -1 ||  t.prop.indexOf(text) != -1))

        myList.push(...list)
        return myList.map(t=>`/*${t.label}*/"${t.prop}"`)
    },
    // 表头合并设置
    getColumns(prop) {
      let selectValue = "";
      if (this.data.mergeHeader) {
        this.data.mergeHeader.forEach((t) => {
          if (t.value && t.prop != prop) {
            selectValue += `${t.value},`;
          }
        });
      }
      return this.columns.filter(
        (t) => t.value != prop && selectValue.indexOf(t.value) == -1
      );
    },
    handleAddCol() {
      if (this.data.mergeHeader == undefined) {
        this.$set(this.data, "mergeHeader", []);
      }
      this.data.mergeHeader.push({
        label: `第${this.data.mergeHeader.length}列`,
        prop: this.$uuid(),
        value: "",
        align: "left",
      });
    },
    handleRemoveCol(index) {
      this.data.mergeHeader.splice(index, 1);
    },
  }
}
</script>

